class MockDataService {
  constructor() {
    this.mockData = [];
  }

  // Генерация тестовых данных
  generateMockData(keywords, count = 10) {
    const mockData = [];
    const sources = ['CNN', 'BBC', 'Reuters', 'Associated Press', 'The Guardian'];
    const keywordsList = Array.isArray(keywords) ? keywords : [keywords];
    
    for (let i = 0; i < count; i++) {
      const keyword = keywordsList[Math.floor(Math.random() * keywordsList.length)];
      const source = sources[Math.floor(Math.random() * sources.length)];
      const date = new Date();
      date.setHours(date.getHours() - Math.floor(Math.random() * 24));
      
      mockData.push({
        title: `${keyword} - Тестовая новость ${i + 1}`,
        description: `Это тестовое описание новости о ${keyword}. Здесь может быть любой текст, описывающий содержание новости.`,
        url: `https://example.com/news/${i + 1}`,
        image: `https://picsum.photos/id/${Math.floor(Math.random() * 1000)}/800/400`,
        publishedAt: date.toISOString(),
        source: source,
        apiSource: 'mock'
      });
    }
    
    this.mockData = mockData;
    return mockData;
  }

  async getNews(keywords, language, hoursAgo) {
    console.log(`Получение тестовых новостей для ключевых слов: ${keywords.join(', ')}`);
    return this.generateMockData(keywords, 15);
  }
}

export default new MockDataService();